module.exports = require('./dist/src/connect/connect');
